import NextImage from "next/image";
import NextLink from "next/link";
import { ModelsCaseCard } from "../../../types";
import { Text } from "../../ui/text";
import { caseCardVariant } from "./case-card.variants";
import { Button } from "../../ui/button";

type CaseCardProps = ModelsCaseCard;

function CaseCard(props: CaseCardProps) {
  const {
    title = "",
    description = "",
    categoryName = "",
    heroImage,
    logo,
    url = "",
    cardButtonLabel = "",
  } = props;
  const styles = caseCardVariant();

  return (
    <article className={styles.base()} data-component-name="case-card">
      <div className={styles.figure()}>
        <NextImage
          alt={title || ""}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          fill
          src={heroImage.url}
          className={styles.image()}
        />
        {!!logo && (
          <div className={styles.logo()}>
            <NextImage
              alt={logo.alternativeText || ""}
              width={logo.width}
              height={logo.height}
              src={logo.url}
            />
          </div>
        )}
      </div>

      <div className={styles.textWrapper()}>
        {!!categoryName && (
          <Text
            tag="span"
            size="small"
            theme="dark"
            weight="semibold"
            className={styles.category()}
          >
            {categoryName}
          </Text>
        )}
        <NextLink href={`${url}`} title={title || ""} className={styles.link()}>
          <Text
            tag="h3"
            size="body"
            theme="dark"
            weight="medium"
            className={styles.title()}
          >
            {title}
          </Text>
        </NextLink>
        {!!description && (
          <Text
            tag="p"
            size="body"
            theme="dark"
            weight="medium"
            className={styles.description()}
          >
            {description}
          </Text>
        )}
        <Button
          tabIndex={0}
          color="blueLight"
          appearance="link"
          sectionName="case-card"
          size="md"
          weight="semibold"
          href={url}
          title={cardButtonLabel}
          endIcon="arrow-right"
        >
          {cardButtonLabel || "Read more"}
        </Button>
      </div>
    </article>
  );
}

export default CaseCard;
